import gql from 'graphql-tag';

import { executeGqlMutation } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';

import { FRAGMENT_LONG_FORM_BUILDER_DRAFT } from './schema';

const MUTATION = gql`
  mutation DeleteLongFormBuilderDraft($projectId: ID!, $draftId: ID!) {
    deleteLongFormBuilderDraft(projectId: $projectId, draftId: $draftId) {
      ...LongFormBuilderDraft
    }
  }
  ${FRAGMENT_LONG_FORM_BUILDER_DRAFT}
`;

export const deleteLongFormBuilderDraft = ({ projectId, draftId }) => {
  return executeGqlMutation({
    mutation: MUTATION,
    variables: { projectId, draftId },
  }).then(({ data }) => getSingleProp(data));
};
